import { IColuna } from "app/types/IColuna";
import React from "react";
import { TraduzirNomeColunaPesquisaOrcamento } from "./TraduzirNomeColunaPesquisaOrcamento";
import { EstilosIndividuaisNomeColunasPesquiaOrcamento } from "./EstilosIndividuaisNomeColunasPesquiaOrcamento";

export type HeadPesquisaOrcamentoProps = {
    colunas: IColuna[];
};

const HeadPesquisaOrcamento = ({ colunas }: HeadPesquisaOrcamentoProps) => {
    return (
        <thead>
            <tr>
                {colunas.map(
                    (coluna, key) =>
                        coluna.Selecionada && (
                            <th
                                key={key}
                                style={{
                                    whiteSpace: 'normal',
                                    ...EstilosIndividuaisNomeColunasPesquiaOrcamento({
                                        nomeColuna: coluna.Nome,
                                        header: true,
                                    }),
                                }}
                            >
                                {TraduzirNomeColunaPesquisaOrcamento({ nomeColuna: coluna.Nome })}
                            </th>
                        )
                )}
            </tr>
        </thead>
    );
};

export default React.memo(HeadPesquisaOrcamento);
